import React from "react";
//#region types
import { HighlightedStepProps } from "models/propTypes/chartProps";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import InfoTooltip from "components/common/tooltips/infoTooltip";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const HighlightedStep: React.FC<React.PropsWithChildren<HighlightedStepProps>> = ({
  icon,
  title,
  description,
  children,
  toolTip,
}) => {
  return (
    <Grid container direction="row" className={cssExports.timelineHighlightedStep} columnGap={1.5}>
      {icon ? <Grid item>{icon}</Grid> : <></>}
      <Grid container item xs justifyContent="center" direction="column">
        <div className={cssExports.title}>{title}</div>
        {description ? (
          <Grid container direction="row" columnSpacing={1} className={cssExports.description}>
            {Array.isArray(description)
              ? description.map((text, index) => (
                  <React.Fragment key={index}>
                    <Grid item className={cssExports.subText}>
                      {text}
                    </Grid>
                    <Grid item className={cssExports.seperator}>
                      |
                    </Grid>
                  </React.Fragment>
                ))
              : description}
            {toolTip ? (
              <Grid item>
                <InfoTooltip text={toolTip} icon={IconDefinitionConstants.WInfo} placement="right" />
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
      {children}
    </Grid>
  );
};

export default HighlightedStep;
